"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viaJS = void 0;
var chai_1 = require("chai");
var utils_1 = require("@time-input-polyfill/utils");
function viaJS(utils) {
    var $input = utils.$input, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, a11yInitialHtml = utils.a11yInitialHtml, loadPrimaryInput = utils.loadPrimaryInput;
    describe('Segment Navigation - via JS', function () {
        it('Should send focus to hours segment', function () {
            loadPrimaryInput()
                .focus()
                .wait(100)
                .then(function (jQueryInputElem) {
                var segment = (0, utils_1.getCursorSegment)($input(jQueryInputElem));
                var expectation = 'hrs12';
                (0, chai_1.expect)(segment).to.eq(expectation);
                return jQueryInputElem;
            })
                .blur()
                .focus()
                .then(a11yHasExpectedHtml(a11yInitialHtml().focus));
        });
    });
}
exports.viaJS = viaJS;
